import Price from './price';

interface TitleProps {
  price: number | null;
  name: string;
  uinsql: string;
}

export default function Title({ price, name, uinsql }: TitleProps) {
  const outlet = uinsql[0] === 'M';

  const itemName = outlet
    ? name.replace('מציאון ועודפים - ', '').replace('מציאון ועודפים', '')
    : name;

  return (
    <div className="my-2 flex w-full items-center justify-between">
      <div className="flex items-center">
        <h1 className="text-sm font-semibold leading-none tracking-wide text-gray-800 sm:text-base md:text-lg lg:text-2xl dark:text-gray-100">
          {outlet && (
            <span className="me-2 rounded-md bg-orange-400 px-2 py-1 text-lg text-white">
              מציאון
            </span>
          )}
          {itemName}
        </h1>
      </div>
      <Price price={price} />
    </div>
  );
}
